import { useState } from "react";
import "./Stylesheets/Navbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faBars } from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/fontawesome-free/css/all.min.css";
import logo from "./Images/download.jpeg";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);       // hamburger
  const [showStocking, setShowStocking] = useState(false); // dropdown

  return (
    <div className="navbar-outer-container">
      <div className="navbar-container">
        <div className="navbar-top-row">{/* optional top mini-links */}</div>

        <div
          className="hamburger"
          onClick={() => setMenuOpen(v => !v)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <FontAwesomeIcon icon={faTimes} /> : <FontAwesomeIcon icon={faBars} />}
        </div>

        <img className="fish-logo" src={logo} alt="Logo" />
      </div>

      {/* Overlay appears only when dropdown is open; click anywhere to close */}
      {showStocking && (
        <button
          className="nav-overlay"
          aria-label="Close menu"
          onClick={() => setShowStocking(false)}
        />
      )}

      <div className={`navbar ${menuOpen ? "slide" : ""}`}>
        <ul className="navbar-options">
          <li><a href="#Coaches"  onClick={() => setMenuOpen(false)}>HOME</a></li>
          <li><a href="#Schedule" onClick={() => setMenuOpen(false)}>MEMBERSHIP</a></li>
          <li><a href="#Pricing"  onClick={() => setMenuOpen(false)}>NEWS</a></li>

          {/* Dropdown (click to toggle; overlay closes anywhere outside) */}
          <li className={`regulations ${showStocking ? "open" : ""}`}>
            <div
        
              className="nav-link"
              aria-haspopup="true"
              aria-expanded={showStocking}
              onClick={() => setShowStocking(v => !v)}
            >
              STOCKING &amp; REGULATIONS {showStocking ? <span className="dropdown rotated">▾</span>  : <span className="dropdown">▾</span>   }
            </div>

            <ul className="submenu">
              <li><a href="#Coaches"  onClick={() => { setMenuOpen(false); setShowStocking(false); }}>FISH HEALTH</a></li>
              <li><a href="#Schedule" onClick={() => { setMenuOpen(false); setShowStocking(false); }}>AQUA REGULATIONS</a></li>
              <li><a href="#Pricing"  onClick={() => { setMenuOpen(false); setShowStocking(false); }}>FEE FISHING</a></li>
              <li><a href="#Pricing"  onClick={() => { setMenuOpen(false); setShowStocking(false); }}>FISH STOCKING</a></li>
            </ul>
          </li>
 
          <li><a href="#Pricing" onClick={() => setMenuOpen(false)}>TUTORIALS</a></li>
   
          <li><a href="#Pricing" onClick={() => setMenuOpen(false)}>MARKETPLACE</a></li>
          <li><a href="#FAQ"     onClick={() => setMenuOpen(false)}>CONTACT</a></li>
          
        </ul>
      </div>
    </div>
  );
}
